module.exports = __webpack_public_path__ + "static/media/01-image.67134f1e.png";